import { Component, OnInit } from '@angular/core';
import { SharedService } from 'app/modules/common/services/shared-service';
import { EmpresaTreeViewService } from 'app/modules/employee/services/empresa-treeView.service';
import { CoordinatorStatisticsService } from '../../services/coordinator-statistics.service';

@Component({
    selector: 'app-coordinator-statistics',
    templateUrl: './coordinator-statistics.component.html',
    styleUrls: ['./coordinator-statistics.component.scss'],
    standalone: false
})
export class CoordinatorStatisticsComponent implements OnInit {

  public selectedCompanyId = 0;
  public isLoading = true;

  constructor(
    public coordinatorStatisticsService: CoordinatorStatisticsService,
    private empresaTreeViewService: EmpresaTreeViewService,
    private sharedService: SharedService) {
    this.registerTreeViewListener();
  }

  ngOnInit(): void {
    this.selectedCompanyId = JSON.parse(localStorage.getItem('Empresa'));
    if(this.selectedCompanyId > 0) {
      this.checkStatisticsAvailability();
    }
  }

  private registerTreeViewListener(): void {
    this.empresaTreeViewService.EmpId.subscribe(res => {
      this.selectedCompanyId = res;
      if (this.selectedCompanyId > 0) {
        this.checkStatisticsAvailability();
      }
    });
  }

  private checkStatisticsAvailability(): void {
    this.isLoading = true;
    this.empresaTreeViewService.getEmpresa(this.selectedCompanyId).subscribe(empRes => {
      if(empRes.code === 0) {
        this.coordinatorStatisticsService.isStatisticsHidden = empRes.result.padreId === 0;
      } else {
        this.sharedService.ShowSnackBar('Error al recuperar los datos de la empresa.');
      }
      this.isLoading = false;
    }, error => {
      console.error(error);
      this.coordinatorStatisticsService.isStatisticsHidden = true;
      this.isLoading = false;
      this.sharedService.ShowSnackBar('Se produjo un error, actualice la página.');
    });
  }

}
